module.exports = __webpack_public_path__ + "static/Logo-02-582da5d95c61aabcc5e244c936fb8616.png";